var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 77,
    viewBox: "0 0 90 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3211 66.7535C21.2183 66.4235 16.3696 64.7443 12.4676 61.9555C8.56555 59.1667 5.80963 55.411 4.59332 51.2247C3.37702 47.0384 3.76253 42.6355 5.69481 38.6446C7.62709 34.6538 11.0073 31.2791 15.3529 29.0024C16.2775 22.9311 19.7977 17.3516 25.2546 13.308C30.7116 9.26437 37.7313 7.03386 45 7.03386C52.2688 7.03386 59.2885 9.26437 64.7454 13.308C70.2023 17.3516 73.7225 22.9311 74.6471 29.0024C78.9927 31.2791 82.3729 34.6538 84.3052 38.6446C86.2375 42.6355 86.623 47.0384 85.4067 51.2247C84.1904 55.411 81.4345 59.1667 77.5324 61.9555C73.6304 64.7443 68.7818 66.4235 63.6789 66.7535V66.8132H26.3211V66.7535ZM48.7358 41.6459H59.9431L45 25.9163L30.0569 41.6459H41.2642V54.2296H48.7358V41.6459Z",
    fill: "#1776EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.0b1bf02c0c268a2db889883a3eedbe08.svg";
export { ForwardRef as ReactComponent };